const LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

export const AlphabetBar = ({ active, available, onSelect }) => (
  <div className="flex flex-wrap gap-1.5" data-testid="alphabet-bar">
    <button
      onClick={() => onSelect(null)}
      data-testid="letter-all"
      className={`h-9 rounded-lg border-2 border-[var(--ink)] px-3 text-sm font-extrabold transition-colors ${!active ? "bg-[var(--ink)] text-white" : "bg-white hover:bg-[var(--sun)]"}`}
    >
      Tutte
    </button>
    {LETTERS.map((l) => {
      const has = available.has(l);
      return (
        <button
          key={l}
          disabled={!has}
          onClick={() => onSelect(l)}
          data-testid={`letter-${l.toLowerCase()}`}
          className={`font-display h-9 w-9 rounded-lg border-2 text-sm font-bold transition-colors ${
            active === l ? "border-[var(--ink)] bg-[var(--ink)] text-white" : has ? "border-[var(--ink)] bg-white hover:bg-[var(--sun)]" : "border-neutral-300 text-neutral-300"
          }`}
        >
          {l}
        </button>
      );
    })}
  </div>
);
